<template>

  <m-shopping-cart-wrapper @order="setOrderDescription">

    <b-container class="my-5"
                 slot-scope="{order,products,deliveryPrice,deliveryBoundary,freeCities,payDescript,addresses}">

      <div class="" v-if="products.length > 0">

        <form @submit.prevent="onSubmit(order)">
          <b-row align-h="center">
            <b-col lg="5" md="5" class="d-inline-block" v-for="item in products" :key="item.id">
              <m-c304 class="col-lg-12 my-1" :image="item.product.thumbnail" :alt="item.product.name">
                <template #p-1>
                  <h5>{{ item.product.name }}</h5>
                  <h6>{{ productName(item) }}</h6>
                  <p>
                    {{ formatNumber(productPrice(item)['price'] - productPrice(item)['offer']) }}
                    <span v-if="productPrice(item)['offer'] > 0" class="badge badge-primary rounded-pill">{{
                        formatNumber(productPrice(item)['offer'])
                      }}</span>
                  </p>

                </template>
                <template #p-2>
                  <m-shopping-cart-quantity-manager-1 :order="order" :item="item"/>
                </template>
              </m-c304>
            </b-col>
          </b-row>

          <b-row>

            <b-col class="my-3" lg="3">

              <div class="bg-white  py-1 col-lg-12 shopping-cart-box">
                <p> قابل پرداخت: <span class="mx-1">{{ formatNumber(order.paying_amount) }}</span></p>
                <p> بدون تخفیف:<span class="mx-1">{{ formatNumber(order.total_amount) }}</span></p>
                <p> تخفیف:<span class="mx-1">{{ formatNumber(order.offer_amount) }}</span></p>

                <div :class="{'line-through':isDeliveryFree(deliveryBoundary,order.total_amount)}">
                  <p> هزینه ارسال:
                    <span class="mx-1 ">{{ formatNumber(deliveryPrice) }}</span>
                  </p>
                </div>
              </div>
              <div>
                <p class="text-muted delivery-boundary-font-size ">حداقل خرید برای ارسال رایگان:
                  {{ formatNumber(deliveryBoundary) }}</p>

                <div class="mt-3" v-if="freeCities.length > 0">
                  <span>شهرهایی که ارسال به آنها رایگان است:</span>
                  <span class=" mx-2 text-success" v-for="city in freeCities">
                {{ city.value.province.name }}-{{ city.value.name }}
                </span>
                </div>
              </div>

            </b-col>
            <b-col class="my-3" lg="3">
              <div class="bg-white  h-100 py-1 col-lg-12 shopping-cart-box">
                <p>توضیحات:</p>
                {{ payDescript }}
              </div>
            </b-col>
            <b-col class="my-3" v-if="orderHavePhysicalProduct(order)" lg="6">
              <div class="bg-white  h-100 py-1 col-lg-12 shopping-cart-box">
                انتخاب آدرس:

                <b-button variant="transparent" class="float-left m-0 p-0" v-b-modal.create-address>
                  <m-icon icon="plus-circle"/>
                </b-button>

                <b-modal size="lg" hide-footer id="create-address">
                  <address-form title="ساخت آدرس جدید" :submit-function="createAddress"/>
                </b-modal>


                <form-group :validations="$v.form.address">
                  <div slot-scope="{ errors, invalid }">
                    <b-form-select
                        class="mt-3"
                        v-model="form.address"
                        :options="setAddresses(addresses,order)"
                        :class="{ invalid }"
                    ></b-form-select>
                    <form-errors-manager :errors="errors"/>
                  </div>
                </form-group>


                <form-group :validations="$v.form.order_description">
                  <div slot-scope="{ errors, invalid }">
                    <b-form-textarea
                        class="my-4"
                        id="textarea"
                        v-model="form.order_description"
                        placeholder="توضیحات سفارش"
                        rows="3"
                        max-rows="3"
                        :class="{ invalid }"
                    ></b-form-textarea>
                    <form-errors-manager :errors="errors"/>
                  </div>
                </form-group>

              </div>
            </b-col>

            <b-col class="my-3" :class="paymentSectionStyle(order)">
              <div class="bg-white  h-100 py-1 col-lg-12 shopping-cart-box">

                <form-group :validations="$v.form.payment_gate">
                  <div slot-scope="{ errors, invalid }">
                    <b-form-group label="روش پرداخت:">
                      <b-form-radio v-model="form.payment_gate" value="zarinpal" name="payment-method">زرین پال
                      </b-form-radio>
                      <form-errors-manager :errors="errors"/>
                    </b-form-group>

                  </div>
                </form-group>


                <b-col lg="12" class="text-center">
                  <b-btn variant="primary" class="col-4" type="submit" pill>پرداخت</b-btn>
                </b-col>


              </div>
            </b-col>


          </b-row>
        </form>


      </div>


      <b-row v-else>
        <div class="empty-cart">
          <img alt="shopping cart" class="mt-3" :src="EmptyCartImage"/>
          <h4 class="my-3">سبد خرید شما خالی است!</h4>
        </div>
      </b-row>
    </b-container>

  </m-shopping-cart-wrapper>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {required, maxLength} from "vuelidate/lib/validators";
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup.vue";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import AddressForm
  from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/dashboard/Address/AddressForm'
import {productPrice, productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "ShoppingCart3",
  components: {FormGroup, FormErrorsManager, AddressForm},
  props: {
    EmptyCartImage: {
      type: String,
      default: require('../assets/empty-cart.svg')
    },
  },
  data() {
    return {
      form: {
        address: '',
        order_description: '',
        payment_gate: ''
      }
    }
  },
  validations: {
    form: {
      address: {required},
      order_description: {maxLength: maxLength(255)},
      payment_gate: {required},
    }
  },
  methods: {
    formatNumber,
    productName,
    productPrice,
    isDeliveryFree(delivery_boundary, price) {
      return parseInt(delivery_boundary) <= parseInt(price)
    },
    setAddresses(addresses, order) {
      let arr = [];
      addresses.forEach((element, key) => {
        if (key === 0) {
          if (order.address != null) {
            this.form.address = order.address.id
          } else {
            this.form.address = element.id
          }
          arr.push({value: element.id, text: element.name});
        } else {
          arr.push({value: element.id, text: element.name});
        }

      });


      return arr;
    },
    setOrderDescription(order) {
      this.form.order_description = order.description
    },
    orderHavePhysicalProduct(order) {
      const products = order.items
      let state = false;

      products.forEach(product => {
        if (product.product.is_digital == 0) {
          state = true;
        }
      })

      return state
    },
    paymentSectionStyle(order) {
      if (this.orderHavePhysicalProduct(order)) {
        return 'col-lg-12';
      }
      return 'col-lg-6'
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async onSubmit(order) {
      if (this.invalid()) {
        const order_id = order.id

        if (this.orderHavePhysicalProduct(order)) {
          let form = {
            order: order_id,
            address_id: this.form.address,
            description: this.form.order_description,
          };
          await this.$store.dispatch("ShoppingCart/chooseAddressAndDescription", form).then(res => {
            this.$store.dispatch("Transaction/createTransaction", order_id);
          });
        } else {
          await this.$store.dispatch("Transaction/createTransaction", order_id);
        }


      }
    },
    async createAddress(form) {
      // Address/createAddress
      await this.$store.dispatch('Address/createAddress', {form}).then(async (res) => {
        await this.$store.dispatch("Address/getOrderAddresses");
        this.$bvModal.hide('create-address')
      })
    }

  }
}
</script>

<style scoped>
.empty-cart {
  font-size: 14px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.line-through {
  text-decoration: line-through;
}

.delivery-boundary-font-size {
  font-size: 13px;
}

.shopping-cart-box {
  border-radius: 25px
}

</style>